import { createAction, props } from "@ngrx/store";
import { IDataAction } from "src/app/utils/interfaces/common.interfaces";
import { IErrorState } from 'src/app/utils/interfaces/store.interfaces';

export enum AppActionsTypes {
  ERROR_EVENT = '[APP] ERROR_EVENT',
  CLEAR_PERMISSION_DATA = '[APP] CLEAR_PERMISSION_DATA',
}

export const errorEventAction = createAction(AppActionsTypes.ERROR_EVENT, props<IDataAction<IErrorState>>());
export const clearPermissionDataAction = createAction(AppActionsTypes.CLEAR_PERMISSION_DATA);